import { useMemo } from "react";
import { useLocation } from "react-router-dom";
/**
 * React hook to retrieve the current Canvas module item id from the URL query string.
 * Returns the `module_item_id` as a string or null if not present.
 */
export function useCurrentModuleItemId(): string | null {
  const location = useLocation();
  const id = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get("module_item_id");
  }, [location.search]);
  return id;
}

export default useCurrentModuleItemId;
